import React from 'react';
import { motion } from 'framer-motion';
import { Countdown } from './ui/Countdown';
export function CountdownUrgency() {
  return <section className="py-12 bg-red-600 text-white border-y-4 border-red-700" data-id="element-63">
      <div className="container mx-auto px-4 text-center" data-id="element-64">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto" data-id="element-65">
          <h2 className="text-2xl md:text-3xl font-black uppercase tracking-wider mb-6" data-id="element-66">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </h2>

          <div className="mb-8" data-id="element-67">
            <Countdown theme="light" className="shadow-2xl scale-110 md:scale-125 origin-center" data-id="element-68" />
          </div>

          <p className="text-xl font-bold text-red-100 mb-8" data-id="element-69">
            ⚠️ Después sube. No vuelve al precio de lanzamiento.
          </p>

          <div className="bg-red-700/50 rounded-xl p-6 max-w-xl mx-auto border border-red-500/30" data-id="element-70">
            <p className="font-bold mb-3 flex items-center justify-center gap-2" data-id="element-71">
              <span className="w-3 h-3 rounded-full bg-red-400 animate-pulse" data-id="element-72"></span>
              Cupos al precio de lanzamiento — Quedan pocos
            </p>

            <div className="w-full bg-red-900/50 rounded-full h-4 mb-2 overflow-hidden border border-red-800" data-id="element-73">
              <motion.div initial={{
              width: 0
            }} whileInView={{
              width: '71%'
            }} transition={{
              duration: 1.5,
              ease: 'easeOut'
            }} className="bg-gradient-to-r from-neon to-[#A5FF00] h-4 rounded-full" data-id="element-74"></motion.div>
            </div>
            <p className="text-sm text-red-200 font-medium text-right" data-id="element-75">
              71% tomados
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}